import { Map } from "immutable";
import TaxisActions from "./actions";

const initState = new Map({
  insurance_taxi_selected: {},
  taxi_form_completed: false,
  taxi_quote_completed: false,
  show_spin_taxis_form: false,
});

export default function TaxisReducer(state = initState, action) {
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.TaxisReducer);
      } else {
        return state;
      }
    case TaxisActions.SET_INSURANCE_TAXI_SELECTED:
      return state.set(
        "insurance_taxi_selected",
        action.insurance_taxi_selected
      );
    case TaxisActions.SET_TAXI_FORM_COMPLETED:
      return state.set("taxi_form_completed", action.completed);
    case TaxisActions.SET_TAXI_QUOTE_COMPLETED:
      return state.set("taxi_quote_completed", action.completed);
    case TaxisActions.SHOW_SPIN_TAXIS_FORM:
      return state.set("show_spin_taxis_form", action.show_spin_taxis_form);
    default:
      return state;
  }
}
